import {ionRangeSlider} from './rangeslider';
import {Utils} from "./Utils";

export interface RangeConfig {
    storage: HTMLInputElement,
    element: HTMLInputElement,
    values: string[]
}

export interface RadioConfig {
    element: HTMLElement,
    values: string[]
}

export class Range {
    private storage: HTMLInputElement;
    private range: {
        element: HTMLInputElement,
        values: string[]
    };
    private radio: {
        element: HTMLElement,
        values: string[],
        items: HTMLCollection
    };

    constructor({storage, element, values}: RangeConfig) {
        this.storage = storage;
        this.range = {element, values};
        this.init();
    }

    public initRadioGroup({element, values}: RadioConfig): void {
        this.radio = {element, values, items: element.children};
        [...this.radio.items].forEach((option: HTMLElement, i) => {
            option.addEventListener(`click`, () => this.onRadioClick(option, i));
        });
    }

    protected onRadioClick(trigger: HTMLElement, i: number): void {
        const {element, values, items} = this.radio;
        element.setAttribute(`data-value`, this.radio.values[i]);
        [...items].forEach((item: HTMLElement) => Utils.removeClass(item, `is-active`));
        Utils.addClass(trigger, `is-active`);
        this.save();
    }

    public save(): void {
        let value = this.range.element.value;
        if (!value) return;

        if (this.radio) {
            let radio = this.radio.element.getAttribute(`data-value`);
            this.storage.value = `${radio}, ${value}`;
        } else {
            this.storage.value = value;
        }
    }

    public init() {
        const {element, values} = this.range;
        ionRangeSlider(element, {
            grid: true,
            values: values,
            onFinish: () => this.save()
        });
    }
}